import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import { ReactComponent as VisibleIcon } from '../assets/icons/visible.svg'
import { ReactComponent as InvisibleIcon } from '../assets/icons/invisible.svg'
import { ReactComponent as Check } from '../assets/icons/checkmark.svg'
import { ReactComponent as DownArrow } from '../assets/icons/chevron-down.svg'
import { ReactComponent as CheckBox } from '../assets/icons/check-box.svg'
import { ReactComponent as CheckedBox } from '../assets/icons/checked-box.svg'
import { ReactComponent as Warning } from '../assets/icons/warning-alt.svg'
import { useForm } from 'react-hook-form'
import { useState } from 'react'

export default function RegisterForm() {
  const [showPassword, setShowPassword] = useState(false)
  const [capsLockOn, setCapsLockOn] = useState(false)
  const [isChecked, setIsChecked] = useState(false)
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isValid },
  } = useForm({ mode: 'onChange' })
  const onSubmit = async (data) => {
    console.log(data)
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='min-w-[390px]'>
        <div className='flex flex-col gap-16'>
          {/* 이메일 */}
          <div className='flex flex-col gap-4'>
            <p className='text-body1-semibold text-label-default'>이메일</p>
            <div className='border_default rounded-8 bg-background-alternative px-16 py-12 text-start text-body1-regular text-label-info'>
              sigma@email.com
            </div>
          </div>
          {/* 비밀번호 */}
          <div className='flex w-full flex-col gap-8'>
            <div className='flex w-full flex-col gap-4'>
              <div className='flex w-full justify-between'>
                <p className='text-body1-semibold text-label-default'>비밀번호</p>
                {capsLockOn && (
                  <p className='rounded-4 bg-background-alternative px-8 py-4 text-caption-regular text-label-info'>
                    Caps Lock이 켜져있습니다
                  </p>
                )}
              </div>
              <div className='relative w-full'>
                <input
                  {...register('password', {
                    required: true,
                    pattern: {
                      value:
                        /^(?:(?=.*[a-zA-Z])(?=.*\d))|(?:(?=.*[a-zA-Z])(?=.*[!@#$%^&*]))|(?:(?=.*\d)(?=.*[!@#$%^&*]))/,
                    },
                    minLength: 10,
                    maxLength: 30,
                  })}
                  type={showPassword ? 'text' : 'password'}
                  onClick={(e) => setCapsLockOn(e.getModifierState('CapsLock'))}
                  onKeyUp={(e) => setCapsLockOn(e.getModifierState('CapsLock'))}
                  className={`${errors.password ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                  placeholder='비밀번호를 입력하세요'
                />
                {/* <span className='text-caption-regular text-status-negative'>
                  {errors?.password?.message}
                </span> */}
                {watch('password') && (
                  <div className='absolute right-16 top-16 flex gap-16'>
                    <button
                      type='button'
                      onClick={() => setValue('password', '')}
                      className='cursor-pointer'
                    >
                      <CloseFilled />
                    </button>
                    <button
                      type='button'
                      onClick={() => setShowPassword((prev) => !prev)}
                      className='cursor-pointer'
                    >
                      {showPassword ? <InvisibleIcon /> : <VisibleIcon />}
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className='flex flex-col gap-2'>
              <div className='flex items-center gap-4 fill-label-info'>
                {errors?.password?.type === ('required' || 'minLength' || 'maxLength') ? (
                  <Warning />
                ) : (
                  <Check className='w-18 h-18' />
                )}
                <p
                  className={`${errors?.password?.type === ('required' || 'minLength' || 'maxLength') ? 'text-status-negative' : 'text-label-info'} text-caption-regular`}
                >
                  최소 10자 이상 최대 30자 이하
                </p>
              </div>
              <div className='flex items-center gap-4 fill-label-info'>
                {errors?.password?.type === 'pattern' ? (
                  <Warning />
                ) : (
                  <Check className='w-18 h-18' />
                )}
                <p
                  className={`${errors?.password?.type === 'pattern' ? 'text-status-negative' : 'text-label-info'} text-caption-regular`}
                >
                  영문자, 숫자, 특수문자 중 2종류 이상 조합
                </p>
              </div>
            </div>
          </div>
          {/* 비밀번호 확인 */}
          <div className='flex w-full flex-col gap-4'>
            <p className='text-body1-semibold text-label-default'>비밀번호 확인</p>
            <div className='relative w-full'>
              <input
                {...register('check', {
                  required: '비밀번호가 일치하지 않습니다. 다시 한번 확인해주세요.',
                })}
                type={showPassword ? 'text' : 'password'}
                className={`${errors.check ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                placeholder='비밀번호를 재입력하세요'
              />
              <span className='text-caption-regular text-status-negative'>
                {errors?.check?.message}
              </span>
              {watch('check') && (
                <div className='absolute right-16 top-16 flex gap-16'>
                  <button
                    type='button'
                    onClick={() => setValue('check', '')}
                    className='cursor-pointer'
                  >
                    <CloseFilled />
                  </button>
                  <button
                    type='button'
                    onClick={() => setShowPassword((prev) => !prev)}
                    className='cursor-pointer'
                  >
                    {showPassword ? <InvisibleIcon /> : <VisibleIcon />}
                  </button>
                </div>
              )}
            </div>
          </div>
          {/* 이름 */}
          <div className='flex w-full flex-col gap-4'>
            <p className='text-body1-semibold text-label-default'>이름</p>
            <div className='relative w-full'>
              <input
                {...register('name', {
                  required: '이름을 입력해주세요. ',
                  maxLength: 20,
                })}
                type='text'
                className={`${errors.name ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                placeholder='이름을 입력하세요'
                //   maxLength='20'
                //   onInput={(e) => handleOnInput(e, 20)}
                // defaultValue={location.state.class}
              />
              <span className='text-body3-regular text-status-negative'>
                {errors?.name?.message}
              </span>
              {watch('name') && (
                <button
                  type='button'
                  onClick={() => setValue('name', '')}
                  className='absolute right-16 top-16 cursor-pointer'
                >
                  <CloseFilled />
                </button>
              )}
            </div>
          </div>
          {/* 학교 */}
          <div className='flex flex-col gap-4'>
            <p className='text-body1-semibold text-label-default'>학교</p>
            <div className='border_default rounded-8 bg-background-alternative px-16 py-12 text-start text-body1-regular text-label-info'>
              시그마고등학교
            </div>
          </div>
          {/* 담당 학급 */}
          <div className='flex flex-col gap-6'>
            <p className='text-body1-semibold text-label-default'>학교</p>
            <div className='flex w-full gap-6'>
              <div className='relative w-full'>
                <select
                  {...register('domain', {
                    required: '도메인을 선택해주세요',
                  })}
                  className={`${errors.domain ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                >
                  <option selected disabled value=''>
                    학년
                  </option>
                  <option>1</option>
                  {/* {majorList?.map((majorItem, majorIndex) => (
              <option key={majorIndex} value={majorItem.id}>
                {majorItem.name}
              </option>
            ))} */}
                </select>
                <DownArrow className='pointer-events-none absolute right-16 top-[14px] h-20 w-20 fill-label-default' />
                {/* <span className='text-caption-regular text-status-negative'>
                  {errors?.domain?.message}
                </span> */}
              </div>
              <div className='relative w-full'>
                <select
                  {...register('class', {
                    required: '담당 학급 정보를 선택해주세요',
                  })}
                  className={`${errors.class ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                >
                  <option selected disabled value=''>
                    반
                  </option>
                  <option>1</option>
                  {/* {majorList?.map((majorItem, majorIndex) => (
              <option key={majorIndex} value={majorItem.id}>
                {majorItem.name}
              </option>
            ))} */}
                </select>
                <DownArrow className='pointer-events-none absolute right-16 top-[14px] h-20 w-20 fill-label-default' />
              </div>
            </div>
            <div onClick={() => setIsChecked((prev) => !prev)} className='flex items-center gap-8'>
              {isChecked ? <CheckedBox /> : <CheckBox />}
              <p className='text-body1-long-regular text-label-info'>담당 학급 없음</p>
            </div>
            <span className='text-caption-regular text-status-negative'>
              {errors?.class?.message}
            </span>
          </div>
          {/* 담당 교과 */}
          <div className='flex flex-col gap-6'>
            <p className='text-body1-semibold text-label-default'>담당 교과</p>
            <div className='relative w-full'>
              <select
                {...register('subject', {
                  required: '담당 교과목 정보를 선택해주세요',
                })}
                className={`${errors.subject ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
              >
                <option selected disabled value=''>
                  교과
                </option>
                <option>1</option>
                {/* {majorList?.map((majorItem, majorIndex) => (
              <option key={majorIndex} value={majorItem.id}>
                {majorItem.name}
              </option>
            ))} */}
              </select>
              <DownArrow className='pointer-events-none absolute right-16 top-[14px] h-20 w-20 fill-label-default' />
              <span className='text-caption-regular text-status-negative'>
                {errors?.subject?.message}
              </span>
            </div>
          </div>
          <button
            type='submit'
            // disabled={!isValid}
            className={`${isValid ? 'button_solid_primary_lg' : 'button_solid_primary_disabled_lg'} w-full`}
          >
            가입 신청
          </button>
        </div>
      </div>
    </form>
  )
}
